import React from 'react';

import { mediumGray, white } from 'utils/color-styles';

interface OrganizationChipProps {
  organization?: {
    name: string;
    logo?: string | null;
    mainPicture?: string | null;
  };
  size?: 'small';
}

const OrganizationChip = ({ organization, size }: OrganizationChipProps): JSX.Element => {
  const logo = organization?.logo || organization?.mainPicture;
  const isSmall = size === 'small';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: white,
        borderRadius: isSmall ? 12 : 16,
        borderWidth: 1,
        borderColor: mediumGray,
        borderStyle: 'solid',
        height: isSmall ? 24 : 32,
        overflow: 'hidden',
        padding: logo ? 0 : '6px 2px',
        marginRight: 12,
        marginBottom: 12,
        maxWidth: 'fit-content',
      }}
    >
      {logo ? (
        <img
          alt={organization?.name}
          src={logo}
          style={{
            width: isSmall ? 20 : 28,
            height: isSmall ? 20 : 28,
            borderRadius: 16,
            margin: 1,
            overflow: 'hidden',
          }}
        />
      ) : null}
      <div
        style={{
          fontSize: 12,
          marginLeft: logo ? 6 : 12,
          marginRight: 12,
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          flex: 1,
        }}
      >
        {organization?.name || 'N/A'}
      </div>
    </div>
  );
};

export default OrganizationChip;
